import {Component} from "@angular/core";
import {AuthorizationService} from "../Authorization/AuthorizationService";

@Component({
    providers: [AuthorizationService],
    template: "Conclude"
})
export class ConcludeSSOLoginComponent {
    constructor(private authorizationService: AuthorizationService) {
        authorizationService.concludeSSOLogin();
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Authorization/ConcludeSSOLoginComponent.ts